export default __webpack_public_path__ + "static/media/Big Breakfast - proportioned_170.a4757a8e.jpg";